<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>招招盈关系</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="服务者编号">
          <el-input v-model="listQuery.workerNo" placeholder clearable></el-input>
        </el-form-item>
        <el-form-item label="服务者姓名">
          <el-input v-model="listQuery.workerName" placeholder clearable></el-input>
        </el-form-item>
        <el-form-item label="师傅编号">
          <el-input v-model="listQuery.mastWorkerNo" placeholder clearable></el-input>
        </el-form-item>
        <el-form-item label="师傅姓名">
          <el-input v-model="listQuery.mastWorkerName" placeholder clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column type="index" label="序号" width="55"></el-table-column>

        <el-table-column prop="masterWorkerId" label="师傅服务者id"></el-table-column>
        <el-table-column prop="masterWorkerNo" label="师傅服务者编号"></el-table-column>
        <el-table-column prop="masterWorkerName" label="师傅姓名"></el-table-column>

        <el-table-column prop="workerId" label="徒弟id"></el-table-column>
        <el-table-column prop="workerNo" label="徒弟服务者编号"></el-table-column>
        <el-table-column prop="workerName" label="徒弟姓名"></el-table-column>
        <el-table-column prop="grandMasterWorkerNo" label="师祖服务者编号"></el-table-column>
        <el-table-column prop="grandMasterWorkerName" label="师祖姓名"></el-table-column>
        <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>
        <el-table-column prop="updateTime" :formatter="dateFormatA" label="修改时间"></el-table-column>
        <!-- <el-table-column prop="updateTime" :formatter="dateFormatA" label="修改时间"></el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />
    </el-card>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
  components: { Pagination },
  data() {
    return {
      workerState: {
        1: "待上线",
        2: "已上线",
        3: "已解约",
        // 4: "复职",
        5: "上线失败"
      },
      cityList: [],
      listData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        workerNo: "",
        workerName: "",
        mastWorkerNo: "",
        mastWorkerName: ""
      }
    };
  },

  created() {
    this.querySearch();
  },
  activated() {},
  methods: {
    //查询
    querySearch() {
      this.listQuery.pageSize = this.pageSize;
      this.listQuery.pageNo = this.currentPage;
      service.$axioGetZzyList(this.listQuery).then(res => {
        if (res.data.errno == 0) {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        }
      });
    }
  },
  beforeCreate() {
    vm = this;
  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>